export default __webpack_public_path__ + "static/media/4.9b88244f.svg";